import React, { useState } from 'react';
import { Tabs } from 'antd';
import { procedureData } from '../../secondUtils/constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ProcedureTabs = (props) => {
    const [activeKey, setActiveKey] = useState("1");
    const history = useHistory()
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const onChange = (key) => {
        setActiveKey(key);
    };
    const tabData = [
        {
            id: 1,
            label: selectedLanguage?.txt_all,
            content: <div className='procedure-cards-div'>
                {
                    procedureData?.map((v, i) => {
                        return (
                            <div data-aos="fade-up"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="300"
                                data-aos-duration="2000">
                                <img src={v?.imageUrl} alt="" />
                                <h2>
                                    {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                </h2>
                                <p>
                                    {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                </p>
                                <button onClick={() => history?.push(v?.path)} className='procedure-cards-btn'>{selectedLanguage?.txt_view_procedure}</button>
                            </div>
                        )
                    })
                }
            </div>
        },
        {
            id: 2,
            label: selectedLanguage?.txt_surgery,
            content: <div className='procedure-cards-div'>
                {
                    procedureData?.slice(0, 3)?.map((v, i) => {
                        return (
                            <div data-aos="fade-up"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="300"
                                data-aos-duration="2000">
                                <img src={v?.imageUrl} alt="" />
                                <h2>
                                    {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                </h2>
                                <p>
                                    {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                </p>
                                <button onClick={() => history?.push(v?.path)} className='procedure-cards-btn'>{selectedLanguage?.txt_view_procedure}</button>
                            </div>
                        )
                    })
                }
            </div>
        },
        {
            id: 3,
            label: selectedLanguage?.txt_basic_procedure,
            content: <div className='procedure-cards-div'>
                {
                    procedureData?.slice(3, 6)?.map((v, i) => {
                        return (
                            <div data-aos="fade-up"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="300"
                                data-aos-duration="2000">
                                <img src={v?.imageUrl} alt="" />
                                <h2>
                                    {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                </h2>
                                <p>
                                    {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                </p>
                                <button className='procedure-cards-btn'>{selectedLanguage?.txt_view_procedure}</button>
                            </div>
                        )
                    })
                }
            </div>
        },
    ];
    return (
        <div className='procedureTabs-div'>
            <Tabs
                activeKey={activeKey}
                defaultActiveKey="1"
                centered
                items={tabData.map(tab => ({
                    label: (
                        <span
                            className={tab.id.toString() === activeKey ? "procedure-active-tab custom-tab-label" : "custom-tab-label"}
                            onClick={() => onChange(tab.id.toString())}
                        >
                            {tab.label}
                        </span>
                    ),
                    key: tab.id.toString(),
                    children: tab.content,
                }))}
            />
        </div>
    )
}

export default ProcedureTabs;
